import React, { useState } from "react";
import { Calendar, Info, Shield } from "lucide-react";
import { ReportingPeriodTimeline } from "./ReportingPeriodTimeline/ReportingPeriodTimeline";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { NoReportingPeriodSelected } from "./NoReportingPeriodSelected/NoReportingPerioidSelected";
import { useAtomValue } from "jotai";
import { SelectedFundAtom } from "@/store/FundStateAtom";
import { SelectedReportingPeriodAtom } from "@/store/ReportingPeriodStateAtom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ValidateReportingPeriodView } from "./ValidateReportingPeriod";
import { MockedDataBar } from "@/components/MockedDataBar";

/**
 * ReportingPeriodsView component
 *
 * Main component for managing reporting periods
 * Shows a timeline for selecting and managing reporting periods
 */
export function ReportingPeriodsView() {
  const selectedFund = useAtomValue(SelectedFundAtom);
  const selectedReportingPeriod = useAtomValue(SelectedReportingPeriodAtom);
  const [activeTab, setActiveTab] = useState<string>("details");

  return (
    <div className="container mx-auto px-4 py-6 max-w-8xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold">Reporting Periods</h1>
      </div>

      {!selectedFund ? (
        <Alert variant="default" className="mb-6">
          <Info className="h-4 w-4" />
          <AlertTitle>No fund selected</AlertTitle>
          <AlertDescription>
            Please select a fund to view and manage reporting periods.
          </AlertDescription>
        </Alert>
      ) : (
        <>
          <Card className="mb-6">
            <CardHeader className="pb-3">
              <CardTitle className="text-xl flex items-center">
                <Calendar className="h-5 w-5 mr-2" />
                Reporting Period Timeline
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ReportingPeriodTimeline />
            </CardContent>
          </Card>

          {!selectedReportingPeriod ? (
            <NoReportingPeriodSelected />
          ) : (
            <Tabs
              defaultValue="details"
              value={activeTab}
              onValueChange={setActiveTab}
            >
           

              {/* <TabsContent value="details"> */}
                <Card>
                  <CardHeader className="pb-3">
                    <CardTitle className="text-xl">
                      Reporting Period Details
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <h3 className="font-medium text-sm text-muted-foreground mb-1">
                          Period Date
                        </h3>
                        <p className="text-lg">
                          {new Date(
                            selectedReportingPeriod.period
                          ).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                        </p>
                      </div>
                      <div>
                        <h3 className="font-medium text-sm text-muted-foreground mb-1">
                          Status
                        </h3>
                        <div className="flex items-center">
                          <span
                            className={`inline-block w-3 h-3 rounded-full mr-2 ${
                              selectedReportingPeriod.isOpen
                                ? "bg-amber-500"
                                : "bg-green-500"
                            }`}
                          ></span>
                          <p className="text-lg">
                            {selectedReportingPeriod.isOpen ? "Open" : "Closed"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              {/* </TabsContent> */}

              {/* <TabsContent value="validate"> */}
                {/* <MockedDataBar /> */}
                {/* <ValidateReportingPeriodView /> */}
              {/* </TabsContent> */}
            </Tabs>
          )}
        </>
      )}
    </div>
  );
}
